export const i18nData = {
  messages: {
    ui: {
      blockTunes: {
        toggler: {
          'Click to tune': 'クリックで調整',
          'or drag to move': 'またはドラッグで移動',
        },
      },
      inlineToolbar: {
        converter: {
          'Convert to': '変換',
        },
      },
      toolbar: {
        toolbox: {
          Add: '追加',
        },
      },
      popover: {
        Filter: 'フィルター',
        'Nothing found': '該当なし',
        'Convert to': '変換',
      },
    },
    toolNames: {
      Text: 'テキスト',
      Heading: '見出し',
      'Unordered List': 'リスト',
      'Ordered List': '番号リスト',
      Table: '表',
      Link: 'リンク',
      Bold: '太字',
      Italic: '斜体',
      Underline: '下線',
      Image: '画像',
    },
    tools: {
      link: {
        'Add a link': 'リンクを追加',
      },
      header: {
        'Heading 2': '大見出し',
        'Heading 3': '中見出し',
        'Heading 4': '小見出し',
      },
      list: {
        Unordered: 'リスト',
        Ordered: '番号リスト',
        'Start with': '開始番号',
      },
      image: {
        Caption: 'キャプション',
        'Select an Image': '画像を選択',
      },
      table: {
        'With headings': 'ヘッダーあり',
        'Without headings': 'ヘッダーなし',
        Stretch: '全幅で表示',
        Collapse: '全幅表示を解除',
        'Add row above': '上に行を追加',
        'Add row below': '下に行を追加',
        'Delete row': '行を削除',
        'Add column to left': '左に列を追加',
        'Add column to right': '右に列を追加',
        'Delete column': '列を削除',
      },
      convertTo: {
        'Convert to': '変換',
      },
    },
    blockTunes: {
      delete: {
        Delete: '削除',
        'Click to delete': 'クリックで削除',
      },
      moveUp: {
        'Move up': '上へ移動',
      },
      moveDown: {
        'Move down': '下へ移動',
      },
    },
  },
}
